import { AirplanemodeInactiveRounded } from '@material-ui/icons'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import React, { useState } from 'react'
import {
  Button,
  ButtonGroup,
  Form,
  Modal,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap'
import { FaMoneyBillWaveAlt } from 'react-icons/fa'
import { toast } from 'react-toastify'
import apinode from '../../services/apinode'

pdfMake.addVirtualFileSystem(pdfFonts)

const SangriaButton = ({ idCx, data_fx }) => {
  const [showModal, setShowModal] = useState(false)
  const [motivo, setMotivo] = useState('')
  const [valor, setValor] = useState('')

  const handleClose = () => setShowModal(false)
  const handleShow = () => setShowModal(true)

  const handleConfirm = async () => {
    // Verifica se os campos 'motivo' e 'valor' estão preenchidos
    if (!motivo || !valor) {
      alert('Por favor, preencha todos os campos!')
      return
    }

    // Pergunta de confirmação antes de enviar a requisição
    const isConfirmed = window.confirm(
      'Você tem certeza que deseja registrar essa retirada?',
    )

    if (!isConfirmed) {
      return // Se o usuário cancelar a confirmação, não faz nada
    }

    // Monta o corpo da requisição para enviar ao servidor
    const requestData = {
      id_cx: idCx, // Este valor pode vir de um campo ou variável específica
      vlr_recebido: valor, // Valor recebido
      motivo_retirada: motivo, // Motivo da retirada
      user: localStorage.idusuario, // Usuário que está fazendo a ação
    }

    try {
      // Realiza a requisição POST para o servidor utilizando 'axios' (apinode)
      const response = await apinode.post(
        `pedido/retirada/${localStorage.idconta}`,
        requestData,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )

      // Verifica se a resposta foi bem-sucedida
      if (response.status === 200) {
        console.log('Retirada registrada com sucesso:', response.data)
        toast.success(response.data.message) // Supondo que a mensagem esteja em response.data.message

        // Gera o PDF apenas se a requisição for bem-sucedida
        const pdfDocGenerator = generatePDF() // Gera o PDF e armazena o objeto gerado
        console.log(pdfDocGenerator)

        // Armazenar o PDF gerado na memória do navegador (localStorage)
        localStorage.setItem(
          'lastGeneratedPDF',
          JSON.stringify(pdfDocGenerator),
        )

        // Abre o PDF em uma nova guia
        // pdfDocGenerator.open();

        /// Limpar os campos após sucesso
        clearFields()

        // Fecha o modal
        handleClose()
      } else {
        console.error('Erro na requisição:', response.statusText)
        alert('Ocorreu um erro ao registrar a retirada.')
      }
    } catch (error) {
      console.error('Erro ao fazer a requisição:', error)
      alert('Ocorreu um erro na comunicação com o servidor.')
    }
  }

  // Função para gerar o PDF e devolver o objeto do PDF
  const generatePDF = () => {
    const docDefinition = {
      content: [
        // Título principal
        {
          text: 'Comprovante de Sangria do Caixa',
          style: 'header',
          alignment: 'center', // Centraliza o título
          margin: [0, 20, 0, 20],
        },

        // Linha separadora
        {
          text: '────────────────────────────────────────────────',
          style: 'lineSeparator',
        },

        // ID do Caixa
        {
          text: `ID do Caixa: ${idCx}`,
          style: 'subheader',
          alignment: 'left', // Alinha à esquerda
          margin: [0, 10, 0, 5],
        },

        // Data e usuário
        {
          text: `Data: ${new Date().toLocaleDateString()}`,
          style: 'subheader',
          alignment: 'left',
          margin: [0, 0, 0, 5],
        },
        {
          text: `User: ${localStorage.username}`,
          style: 'subheader',
          alignment: 'left',
          margin: [0, 0, 0, 15],
        },

        // Motivo da Sangria
        {
          text: 'Motivo da Sangria:',
          style: 'boldLabel',
          margin: [0, 5, 0, 5],
        },
        {
          text: motivo,
          style: 'bodyText',
          margin: [0, 0, 0, 15],
        },

        // Valor da Retirada
        {
          text: 'Valor da Retirada:',
          style: 'boldLabel',
          margin: [0, 10, 0, 5],
        },
        {
          text: `R$ ${parseFloat(valor).toFixed(2)}`,
          style: 'bodyAmount',
          alignment: 'right', // Alinha o valor à direita
          margin: [0, 0, 0, 30],
        },

        // Linha separadora final
        {
          text: '────────────────────────────────────────────────',
          style: 'lineSeparator',
        },

        // Assinatura do usuário
        {
          text: 'Assinatura do Responsável:',
          style: 'boldLabel',
          margin: [0, 10, 0, 5],
        },
        {
          text: '__________________________',
          style: 'bodyText',
          alignment: 'center',
          margin: [0, 0, 0, 20],
        },
      ],

      // Estilos globais
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          color: '#2E8B57', // Cor verde para o título
        },
        subheader: {
          fontSize: 12,
          bold: false,
          color: '#555',
          margin: [0, 3, 0, 3],
        },
        bodyText: {
          fontSize: 12,
          color: '#333', // Cor para o corpo do texto
        },
        bodyAmount: {
          fontSize: 16,
          bold: true,
          color: '#B22222', // Cor vermelha para o valor da retirada
        },
        lineSeparator: {
          fontSize: 10,
          color: '#ddd', // Cor cinza para a linha
          alignment: 'center',
        },
        boldLabel: {
          fontSize: 12,
          bold: true,
          color: '#333', // Cor escura para títulos de rótulos
        },
      },

      // Layout: Define o espaçamento e margens do documento
      pageMargins: [40, 60, 40, 60], // Margens do documento
    }

    // Gerar e abrir o PDF
    pdfMake.createPdf(docDefinition).open()
    return docDefinition
  }

  // Função para limpar os campos após sucesso
  const clearFields = () => {
    setMotivo('') // Assume que 'setMotivo' é a função de setState para o campo motivo
    setValor('') // Assume que 'setValor' é a função de setState para o campo valor
  }

  return (
    <>
      {/* Botão de Sangria */}
      <OverlayTrigger overlay={<Tooltip>Sangria</Tooltip>}>
        <button
          onClick={handleShow}
          disabled={data_fx !== null}
          style={{ fontSize: '10px', cursor: 'pointer' }}
        >
          <FaMoneyBillWaveAlt />
        </button>
      </OverlayTrigger>

      {/* Modal para Motivo */}
      <Modal
        show={showModal}
        onHide={handleClose}
        centered
        backdrop="static" // Garante que o clique no fundo não feche o modal
        dialogClassName="escurecimento-completo-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Registrar Sangria do Caixa</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Motivo da Retirada</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={motivo}
                onChange={(e) => setMotivo(e.target.value)}
                placeholder="Descreva o motivo da retirada"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Valor da Retirada</Form.Label>
              <Form.Control
                type="number"
                value={valor}
                onChange={(e) => setValor(e.target.value)}
                placeholder="Informe o valor a ser retirado"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}
          >
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirm}
          >
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default SangriaButton
